"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightActionsSectionRoot = void 0;
var _mui = require("@ori-ui/mui");
const RightActionsSectionRoot = exports.RightActionsSectionRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(3),
  justifySelf: 'end',
  justifyContent: 'flex-end',
  marginLeft: theme.spacing(3),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'end'
  },
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(4),
    marginLeft: theme.spacing(4),
    maxWidth: 'none'
  },
  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(8),
    marginLeft: theme.spacing(8)
  }
}));
